import { render, staticRenderFns } from "./TabsCardTemplate.vue?vue&type=template&id=e312310c&scoped=true"
import script from "./TabsCardTemplate.vue?vue&type=script&lang=js"
export * from "./TabsCardTemplate.vue?vue&type=script&lang=js"
import style0 from "./TabsCardTemplate.vue?vue&type=style&index=0&id=e312310c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e312310c",
  null
  
)

export default component.exports